import { SvgIcon, SvgIconProps } from "@mui/material";

export const TextIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M4 7V4h16v3M9 20h6M12 4v16"
      />
    </svg>
  </SvgIcon>
);
